
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1063 708.66","version":"1"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"rx":"0","ry":"0","height":"708.66","width":"1063","fill-rule":"evenodd","fill":"#fff"}}),_c('rect',{attrs:{"rx":"0","ry":"0","height":"236.22","width":"1063","y":"475.56","fill-rule":"evenodd","fill":"#21468b"}}),_c('path',{attrs:{"fill-rule":"evenodd","fill":"#ae1c28","d":"M0 0h1063v236.22H0z"}})])
          )
        }
      }
    